<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Tabela de Cidades</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Cidades</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelName }}
                    </th>
                    <th scope="col" class="border-0">{{ labelInitials }}</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(city, index) in cities" :key="index">
                    <td></td>
                    <td class="text-left">{{ city.Name }}</td>
                    <td>
                      {{
                        city.InitialsState == undefined ||
                        city.InitialsState == "" ||
                        city.InitialsState == null
                          ? "-"
                          : city.InitialsState
                      }}
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('City', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenCity($event, index, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('City', 'Update')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenCity($event, index)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="$isAuthorize('City', 'Delete')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="ConfirmDeleteCity(city.Name, city.Id)"
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      cities == undefined ||
                      cities == null ||
                      cities.length == 0
                    "
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      size="sm"
      id="mFormCity"
      :title="modalTitle"
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <!-- Description -->
        <ValidationObserver tag="form" ref="validatedCityForm">
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Estado</label>
              <d-select v-model="infoCity.IdState" :disabled="isSeeing">
                <option :value="null" selected>Selecione</option>
                <option
                  v-for="state in statefilter"
                  v-bind:key="state.Id"
                  v-bind:value="state.Id"
                >
                  {{ state.Name }}
                </option>
              </d-select>
            </d-col>
            <d-col md="12" class="form-group">
              <label>{{ labelName }}</label>
              <ValidationProvider
                rules="required|min:3"
                v-slot="{ errors, invalid }"
              >
                <d-form-input
                  type="text"
                  v-model="infoCity.Name"
                  :class="validatedCityForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                />
                <div class="invalid-feedback d-block" v-if="validatedCityForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <!-- Date -->
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Código IBGE</label>
              <ValidationProvider
                rules="required|min:7 |max:10"
                v-slot="{ errors, invalid }"
              >
                <d-form-input
                  type="text"
                  v-model="infoCity.CodeIBGE"
                  :class="validatedCityForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                />
                <div class="invalid-feedback d-block" v-if="validatedCityForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveCity()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.Initials" :value="null">
            <option :value="null" selected>Selecione</option>
            <option
              v-for="state in statefilter"
              v-bind:key="state.Initials"
              v-bind:value="state.Initials"
            >
              {{ state.Name }}
            </option>
          </d-select>
        </d-col>

        <d-col md="6" class="form-group">
          <input
            :placeholder="labelName"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('City', 'Add')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Nova cidade"
      v-on:click="OpenCity($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import dateField from "../common/date-field";
import { hasValue } from "../../utils/functions.js";
export default {
  name: "city",
  data: function () {
    return {
      loadingList: false,
      loadingModal: false,
      loadingAddUpdate: false,
      labelName: "Cidade",
      labelInitials: "Sigla",
      modalTitle: "Nova Cidade",
      countFilter: 0,
      filter: {
        Name: null,
        Initials: null,
        IdCountry: null,
      },
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      idCity: 0,
      pOpened: null,
      cities: [],
      statefilter: [],
      infoCity: {
        Name: null,
        CodeIBGE: null,
        IdState: null,
      },
      isSeeing: false,
      validatedCityForm: false,
    };
  },
  components: {
    dateField,
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListCity();
    },
    "pagination.RowsPerPage": function () {
      this.ListCity();
    },
  },
  mounted() {
    this.ListCity();
    this.ListStateFilter();
  },
  methods: {
    OpenCity: function (e, i, view) {
      e.preventDefault();
      this.validatedCityForm = false;
      this.ResetInfoCity();

      if (view == undefined && i != undefined) {
        // Edit
        this.pOpened = i;
        this.idCity = this.cities[i].Id;
        this.isSeeing = false;
        this.modalTitle = "Editar Cidade";
        this.GetCity();
      } else if (view == undefined && i == undefined) {
        // Add new
        this.pOpened = null;
        this.ResetInfoCity;
        this.isSeeing = false;
        this.modalTitle = "Nova Cidade";
        this.ResetInfoCity();
      } else {
        // View
        this.pOpened = i;
        this.idCity = this.cities[i].Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes da Cidade";
        this.GetCity();
      }
      this.$bvModal.show("mFormCity");
    },
    ListStateFilter: function () {
      this.$store.dispatch("ListState", { idCountry: 24 }).then((response) => {
        this.statefilter = response;
      });
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListCity();
    },
    ResetFilter: function () {
      this.filter = {
        Initials: null,
        IdCountry: null,
      };
      this.ListCity();
    },
    ResetInfoCity: function () {
      this.infoCity = {
        Name: null,
        CodeIBGE: null,
        IdState: null,
      };
    },
    SaveCity: function () {
      this.validatedCityForm = true;

      this.$refs.validatedCityForm.validate().then((isValid) => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            // Add
            this.$store
              .dispatch("AddCity", this.infoCity)
              .then(() => {
                this.$makeToast(
                  "A cidade foi cadastrada com sucesso.",
                  "success",
                  "Cidade cadastrado"
                );
                this.ListCity();
                this.$bvModal.hide("mFormCity");
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao cadastrar a cidade",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            // Update
            this.$store
              .dispatch("UpdateCity", this.infoCity)
              .then(() => {
                this.$makeToast(
                  "A cidade foi atualizada com sucesso.",
                  "success",
                  "Cidade atualizada"
                );
                this.ListCity();
                this.$bvModal.hide("mFormCity");
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao atualizar a cidade.",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },
    GetCity: function () {
      if (this.idCity != 0) {
        this.loadingModal = true;
        this.$store
          .dispatch("GetCity", { id: this.idCity })
          .then((response) => {
            this.infoCity = response;
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao carregar a cidade",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    ListCity: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Initials)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Name": this.filter.Name,
          "Object.InitialsState": this.filter.Initials,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("CityList", { params: data })
        .then((response) => {
          this.cities = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar as Cidades",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ConfirmDeleteCity: function (description, id) {
      this.$makeMsgBox(
        "Você tem certeza que deseja remover " + description + " ?",
        "Confirmar",
        this.DeleteCity,
        id
      );
    },
    DeleteCity: function (id) {
      this.$store
        .dispatch("DeleteCity", { id: id })
        .then(() => {
          this.$makeToast(
            "A Cidade foi removida com sucesso.",
            "success",
            "Cidade removida"
          );
          this.ListCity();
          this.$bvModal.hide("mFormCity");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao remover a Cidade",
            error
          );
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/cities.vue